import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import useOnClickOutside from 'use-onclickoutside';
import PropTypes from 'prop-types';
import styles from './DropdownSelection.module.scss';

const DropdownSelection = ({ options, value = undefined, onChange }) => {
  const ref = useRef();
  const [isExpanded, setIsExpanded] = useState(false);
  const [hoveredOption, setHoveredOption] = useState();

  const selectedOption = options.find((option) => option.value === value);

  const handleChange = (newValue) => {
    onChange(newValue);
    setIsExpanded(false);
  };

  useOnClickOutside(ref, () => {
    setIsExpanded(false);
  });

  return (
    <div
      ref={ref}
      className={classNames(styles.container, { [styles.opened]: isExpanded })}
    >
      <button
        className={styles.selected}
        type="button"
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <div className={styles['selected-label']}>
          <span>{selectedOption?.label}</span>
        </div>
        <div className={styles.dropdownImg} />
      </button>

      <div className={styles.list}>
        {options.map((option) => (
          <button
            key={option.value}
            data-testid={option.label}
            type="button"
            className={classNames(styles['list-item'], {
              [styles['list-item-disabled']]: option.isDisabled,
              [styles['list-item-selected']]:
                option.value === selectedOption?.value && !hoveredOption,
            })}
            onClick={() => !option.isDisabled && handleChange(option.value)}
            onMouseEnter={() => setHoveredOption(option)}
            onMouseLeave={() => setHoveredOption(undefined)}
          >
            <span className={styles['list-item-label']}>{option.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

DropdownSelection.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isDisabled: PropTypes.bool,
    }),
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default DropdownSelection;
